import { Modal } from 'antd';
import styled from 'styled-components';

export const Container = styled(Modal)`
  .ant-btn span {
    font-size: 1rem;
    font-weight: 500;
  }

  .ant-modal-header {
    border: none;
    padding-bottom: 0;
  }

  .ant-modal-footer {
    padding: 0;
    border: none;
  }

  .ant-modal-body {
    padding: 0;
    overflow: hidden;
    position: relative;
  }

  .ant-modal-content {
    overflow: hidden;
    position: relative;
  }

  .ant-modal-wrap {
    z-index: 1000;
  }

  .anticon svg {
    color: rgba(0, 0, 0, 0.7);
  }

  padding: 0;
  z-index: 1000;
`;
